export enum AccountProvider {
  TrueLayer = 1,
  Google = 2,
  Office = 3,
  HMRC = 4,
}
